<script setup lang="ts">
import { type IconDefinition } from '@fortawesome/fontawesome-common-types';
import { NuxtLink } from '#components';

defineProps<{
    icon: IconDefinition;
    label: string;
    color: string;
    weight: SizeConditional<FontWeights>;
    to?: string;
}>();
const analyticsStore = useAnalyticsStore();
</script>

<template>
    <component
        :is="to ? NuxtLink : 'div'"
        :key="label"
        :to
        rel="nofollow"
        class="nav-option"
        :prefetch="!!to"
        :aria-disabled="!to"
        @click="analyticsStore.trackAll(to || '/panel/reserves')"
    >
        <mr-icon :icon :color />
        <MrTypography size="small" :weight :color>
            {{ label }}
        </MrTypography>
    </component>
</template>

<style scoped lang="scss">
:global(body) {
    padding-bottom: 65px;
}

.mobile {
    @include desktop-only {
        display: none !important;
    }
}

.nav-option {
    all: unset;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 65px;
    flex: 1;
    justify-content: center;
    gap: 4px;
    transition: 0.5s;
    overflow: hidden;
}

.nav-option:after {
    position: absolute;
    content: '';
    width: 10%;
    height: 100%;
    pointer-events: none;
    background-image: radial-gradient(circle, #d8d8d8 10%, transparent 10.01%);
    transform: scale(15, 15);
    opacity: 0;
    overflow: hidden;
    transition:
        transform 0.3s,
        opacity 1s;
}
.nav-option:active:after {
    transform: scale(0, 0);
    opacity: 0.3;
    transition: 0s;
}
</style>
